import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import Header from '../components/header'
import favicon from '../static/images/favicon.ico';
import ogImage from '../static/images/facebook.jpg';
import '../static/stylesheets/app.scss'

const Layout = ({ children, data }) => (
  <div>
    <Helmet
      title={data.site.siteMetadata.title}
      meta={[
        { name: 'description', content: '「コト(事)」と「イロ(個性)」の滲み出るまちの拠点、シェアキッチン&コワーキングから始まる"まち単位のリノベーション"' },
        { name: 'keywords', content: 'cotoiro,co-toiro,コトイロ,岩淵町,シェアキッチン,コワーキング,リノベーション,赤羽,まちづくり,岩淵家守舎' },
        { property: 'og:title', content: 'co-toiro iwabuchi (コトイロ)' },
        { property: 'og:description', content: '「コト(事)」と「イロ(個性)」の滲み出るまちの拠点、シェアキッチン&コワーキングから始まる"まち単位のリノベーション"' },
        { property: 'og:type', content: 'website' },
        { property: 'og:url', content: 'https://www.cotoiro.com' },
        { property: 'og:image', content: ogImage },
        { property: 'og:site_name', content: 'co-toiro iwabuchi (コトイロ)' },
        { property: 'og:locale', content: 'ja-JP' },
        { name: 'twitter:card', content: 'summary' },
        { name: 'twitter:description', content: '「コト(事)」と「イロ(個性)」の滲み出るまちの拠点、シェアキッチン&コワーキングから始まる"まち単位のリノベーション"' },
        { name: 'twitter:image', content: ogImage },
      ]}
    >
      <html lang="ja" />
      <link rel="icon" type="image/png" href={favicon} sizes="16x16" />
      <script>
        {`
        (function(d) {
          let config = {
            kitId: 'prn6ecq',
            scriptTimeout: 3000,
            async: true
          },
          h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\bwf-loading\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)
        })(document);
        `}
      </script>
    </Helmet>
    {/* <Header siteTitle={data.site.siteMetadata.title} /> */}
    <div>
      {children()}
    </div>
  </div>
)

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js